import classNames from 'classnames';
import { IChildrenProps } from 'types/ChildrenProps';
import './SchedulingEventContainer.scss';

export interface ISchedulingEventContainerProps extends IChildrenProps {
  className?: string | object;
}

function SchedulingEventContainer({ children, className }: ISchedulingEventContainerProps) {
  const classes = classNames('scheduling-event-container', className);

  return <div className={classes}>{children}</div>;
}

export default SchedulingEventContainer;
